import type { LucideIcon } from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { Link, useLocation } from "react-router-dom";

export function AppSidebarNav({
  items,
  title,
}: {
  items: {
    title: string;
    url: string;
    icon?: LucideIcon;
  }[];
  title?: string;
}) {
  const location = useLocation();

  return (
    <SidebarGroup>
      {title && <SidebarGroupLabel>{title}</SidebarGroupLabel>}
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          {items.map((item) => {
            // 获取当前路径的 pathname 部分，忽略 query 参数
            const currentPathname = location.pathname;
            const isActive = currentPathname === item.url;

            return (
              <SidebarMenuItem key={item.title}>
                <Link
                  to={item.url}
                  className={cn(
                    "flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50",
                    "data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground",
                    "min-w-8 touch-target py-3 sm:py-2 duration-200 ease-linear hover:bg-primary/5",
                    isActive
                      ? "bg-primary text-primary-foreground duration-200 ease-linear hover:bg-primary/90 hover:text-primary-foreground active:bg-primary/90 active:text-primary-foreground"
                      : "min-w-8 duration-200 ease-linear"
                  )}
                  data-active={isActive}
                >
                  {item.icon && (
                    <item.icon className="h-4 w-4 sm:h-5 sm:w-5" />
                  )}
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
